<template>
    <NuxtLayout>
        <NuxtPage :page-key="route => route.fullPath" />
    </NuxtLayout>
</template>

<script lang="ts" setup>
import { useAuthStore } from '@core/stores/auth';

const authStore = useAuthStore();
authStore.getAuthorizedUser();

</script>
